import { render } from "./ColorButton.vue?vue&type=template&id=36a5e210&scoped=true"
import script from "./ColorButton.vue?vue&type=script&lang=js"
export * from "./ColorButton.vue?vue&type=script&lang=js"

import "./ColorButton.vue?vue&type=style&index=0&id=36a5e210&lang=scss&scoped=true"

import exportComponent from "C:\\work\\prj\\asan\\asan_tpps_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a5e210"]])

export default __exports__